import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure
} from '@chakra-ui/react'
import { userListContext } from 'BrokerTsLib/src/context'
import type { UserGridItem, UserPagedQuery } from 'BrokerTsLib/src/dtos'
import { useSearchUsers } from 'BrokerTsLib/src/hooks/useUser'
import { useState } from 'react'

import { Add } from '../../icons'
import {
  UserList,
  UserListEmailColumn,
  UserListNameColumn,
  UserListOrganizationColumn,
  UserListRolesColumn,
  UserListTypeColumn,
  UserListValidityColumn
} from '../user/UserList'
import { AddButton } from './AddButton'

const pageSize = 15
export const AddFlexGroupUser = ({
  onAddUser,
  alreadyAdded,
}: {
  onAddUser: (userId: string) => Promise<any>
  alreadyAdded: UserGridItem[]
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [filter, setFilter] = useState<UserPagedQuery>({
    showInvalid: false,
    pageIndex: 1,
    pageSize,
  })

  const { data, refetch, isLoading } = useSearchUsers(filter, { enabled: isOpen })

  const users = data?.data.items ?? []

  return (
    <Box>
      <Button
        colorScheme="primary"
        variant="link"
        onClick={() => onOpen()}
        whiteSpace="nowrap"
      >
        <Add /> Přidat uživatele
      </Button>
      <Modal size="6xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>
            <Text>Přidat uživatele</Text>
            <ModalCloseButton />
          </ModalHeader>

          <ModalBody sx={{ pt: 0, pb: 0 }}>
            <userListContext.Provider
              value={{
                loading: isLoading,
                totalCount: data?.data.totalCount ?? 0,
                currentPage: filter.pageIndex,
                pageSize,
                filter,
                setCurrentPage: (p: number) => setFilter((f) => ({ ...f, pageIndex: p })),
                setPageSize: () => { },
                updateFilter: setFilter,
                reload: () => refetch(),
              }}
            >
              <Flex flexDir={'column'}>
                <UserList
                  users={users}
                  columnsDefinition={[
                    {
                      accessorKey: 'addToFlexGroup',
                      header: '',
                      cell: info => {
                        const item = info.row.original
                        return (
                          <AddButton
                            alreadyAdded={alreadyAdded.some((x) => x.userId === item.userId)}
                            onClick={() => onAddUser(item.userId)} />
                        )
                      },
                      meta: { cellProps: { p: 0, px: 2, w: 0 } },
                    },
                    UserListNameColumn,
                    UserListOrganizationColumn,
                    UserListEmailColumn,
                    UserListValidityColumn,
                    UserListTypeColumn,
                    UserListRolesColumn,
                  ]}
                />
              </Flex>
            </userListContext.Provider>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  )
}